const namespace = 'campaigns';

export const CANNOT_CREATE_SPECIAL_PROMO = `${namespace}/CANNOT_CREATE_SPECIAL_PROMO`;
